// removed by extract-text-webpack-plugin
module.exports = {"designs":"designs_2BguW","notes":"notes_c0oH7","book":"book_3FLJz","active":"active_1-kOs","thumbnail":"thumbnail_3sqaS","label":"label_3YgGS"};


//////////////////
// WEBPACK FOOTER
// ./app/components/design/styles.scss
// module id = 425
// module chunks = 1